import React, {useMemo, useState} from 'react';
import IngredientsCard from "../../cards/IngredientsCard";
import RecipesCard from "../../cards/RecipesCard";
import {getCurrentTime} from "../../../helpers/dateHelper";
import {addUpRecipeStats} from "../../modals/AddRecipeModal";
import {useQuery} from "react-query";
import {fetchIngredients, fetchRecipes} from "../../../api/foodApiHandler";
import {toDict} from "../../../helpers/helpers";

function FoodData(props) {
    const [date, _setDate] = useState(getCurrentTime())
    const ingredientsQuery = useQuery({
        queryKey: ['food', 'ingredients'],
        queryFn: fetchIngredients
    })

    const recipes = useQuery({
        queryKey: 'recipes',
        queryFn: () => fetchRecipes()
    })

    const ingredientsAsDict = useMemo(
        () => {
            if (ingredientsQuery.isSuccess) {
                return toDict(ingredientsQuery.data)
            }
            return {}
        }, [ingredientsQuery.data, ingredientsQuery.isSuccess]
    )

    let recipesList = []
    let ingredientsList = []
    if (ingredientsQuery.isSuccess && recipes.isSuccess) {
        recipesList = recipes.data
        ingredientsList = ingredientsQuery.data

        for (let recipe of recipesList) {
            recipe["stats"] = addUpRecipeStats(1, recipe["ingredients"], ingredientsAsDict)
        }
    }

    return (
        <div className="container-fluid">
            <div className="mb-4">
                <h1 className="h3 mb-0 text-gray-800" style={{display: 'inline'}}>Food data</h1>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <RecipesCard day={date} recipes={recipesList} title={"Recipes"}
                                 showModal={(editData = null, clone=false) => {
                                     props.showRecipeModal()
                                     if (editData) {
                                         if (clone) {
                                             props.setRecipeEditData({...editData, _id: null, name: editData.name + " (clone)"})
                                         } else {
                                             props.setRecipeEditData(editData)
                                         }
                                     }
                                 }}/>
                </div>
                <div className="col-lg-6">
                    <IngredientsCard ingredients={ingredientsList} title={"Ingredients"}
                                     showModal={(editData = null) => {
                                         props.showIngredientModal()
                                         if (editData) {
                                             props.setIngredientEditData({
                                                 name: "", serving_size_amount: "", serving_size_unit: "g", "stats": {
                                                     "energy-kcal_100g": "",
                                                     "carbohydrates_100g": "",
                                                     "fat_100g": "",
                                                     "proteins_100g": "",
                                                     "energy-kcal_serving": "",
                                                     "carbohydrates_serving": "",
                                                     "fat_serving": "",
                                                     "proteins_serving": "",
                                                 },
                                                 alternative_names: "",
                                                 ...editData
                                             })
                                         }
                                     }}/>
                </div>
            </div>
        </div>
    )
}

export default FoodData;